export function BillingPage () {
  return (
    <div>
      <h1 className='heading-lg mb-6'>Billing</h1>
    </div>
  )
}
